module.exports = __webpack_public_path__ + "img/C06TechWarChariotChampion_ua.e18dfb8b.webp";